<template>
  <div
    :class="wrapperClass ? `${wrapperClass} a-avatar-edition` : 'a-avatar-edition'"
  >
    <span :class="`a-avatar-primary a-avatar-${avatarClass} margin-right-medium`">
      <img
        v-if="avatarImg.length"
        key="avatarImgTag"
        id="avatarImgTag"
        :src="avatarImg"
      >
      <img
        v-else
        key="defaultImg"
        id="avatarImgTag"
        src="@/assets/img/avatar.png"
      >
    </span>

    <span class="display-flex-column font-weight-light margin-zero">
      <span><b>{{ userInfo.email }}</b></span>
      <span class="text-color-success">
        activo desde {{ $moment.parseZone(userInfo.fecha_alta).format('D MMMM YYYY') }}
      </span>
      <a
        class="font-weight-regular text-link-hover-account"
        href="#"
        @click.prevent="changeAvatarImage('inputImagen')"
      >
        {{ isFamilyAvatar ? $t('aAvatarEdition.changetLogo') : $t('aAvatarEdition.changeAvatar') }}
      </a>
      <input
        v-show="false"
        name="file"
        id="inputImagen"
        ref="file"
        type="file"
        value=""
        @change="previewAvatarImage"
      >
    </span>
  </div>
</template>

<script>
export default {
  name: 'AtomAvatarEdition',

  props: {
    avatarClass: {
      type: String,
      default: 'small'
    },

    avatarImg: {
      type: String,
      default: ''
    },

    isFamilyAvatar: {
      type: Boolean,
      default: false
    },

    userInfo: {
      type: Object,
      default: () => ({ email: 'usuario@email.com', fecha_alta: '' })
    },

    wrapperClass: String
  },

  data () {
    return {
      isFileExtensionValid: true,
      isFileSizeValid: true
    }
  },

  methods: {
    changeAvatarImage (inputId) {
      document.getElementById(inputId).click()
    },

    previewAvatarImage (event) {
      let input = event.target
      this.isFileExtensionValid = this.$files.allowedFileExtension(input.files[0].name, 'image')
      this.isFileSizeValid = this.$files.allowedFileSize(input.files[0].size)
      if (input.files && input.files[0] && this.isFileExtensionValid && this.isFileSizeValid) {
        var reader = new FileReader()
        reader.onload = (e) => {
          document.getElementById('avatarImgTag').src = e.target.result
          this.$emit('changeAvatarImage', e.target.result)
        }
        reader.readAsDataURL(input.files[0])
      } else if (!this.isFileExtensionValid) {
        this.$modal.showModal('MoleculeContentEditorModalImageExtensionError')
      } else if (!this.isFileSizeValid) {
        this.$modal.showModal('MoleculeContentEditorModalFileSizeError')
      }
    }
  }
}
</script>
